import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';
import apiSDK from '@/services/apiSdk';
import { queryKeys } from '../queryClient';
import { ParamsStoreManagement } from './types';

export interface Summary {
    stores: number;
    monthMinusOne: number;
    monthMinusTwo: number;
    monthMinusThree: number;
    variation: number;
}

export function useStoreManagementSummary(params?: ParamsStoreManagement) {
    const queryFn = async () => {
        const response = await apiSDK.store.summary({
            ...params,
        });
        return response;
    };

    return useQuery({
        queryFn,
        retry: false,
        refetchOnWindowFocus: false,
        queryKey: queryKeys.STORE_MANAGEMENT_SUMMARY(params),
    });
}
